import { AccordionBody, AccordionHeader, AccordionItem } from "../../Accordion";
import RadioCard from "../../RadioCard";
import ValidatedField from "../../form/ValidatedField";
import {
  RevisorsSectionProps,
  scrollToRefIfNotInView,
} from "../RevisorsErklaering";

export default function RevisorsHandling5(props: RevisorsSectionProps) {
  const { locked, isCompleteHelpers, formikProps, refs, texts } = props;
  const { revisors_handling_5 } = texts;
  const { values, errors, touched } = formikProps;
  return (
    <AccordionItem value="Handling5">
      <AccordionHeader
        sectionStarted={!!values.revisors_handling_5_question}
        sectionComplete={isCompleteHelpers.revisors_handling_5_complete}
        ref={refs.handling_5_ref}
        onClick={() => {
          scrollToRefIfNotInView(refs.handling_4_ref);
        }}
      >
        {revisors_handling_5.title}
      </AccordionHeader>
      <AccordionBody>
        <fieldset disabled={locked}>
          <legend className="h5 fw-normal mb-4 lh-base">
            {revisors_handling_5.description}
          </legend>
          <div className="vstack gap-3" role="group">
            <RadioCard
              name={revisors_handling_5.revisors_handling_5_question.id}
              value={
                revisors_handling_5.revisors_handling_5_question
                  .revisors_handling_5_question_alt_1.value
              }
              id={
                revisors_handling_5.revisors_handling_5_question
                  .revisors_handling_5_question_alt_1.value
              }
              text={
                revisors_handling_5.revisors_handling_5_question
                  .revisors_handling_5_question_alt_1.label
              }
            ></RadioCard>
            <RadioCard
              name={revisors_handling_5.revisors_handling_5_question.id}
              value={
                revisors_handling_5.revisors_handling_5_question
                  .revisors_handling_5_question_alt_2.value
              }
              id={
                revisors_handling_5.revisors_handling_5_question
                  .revisors_handling_5_question_alt_2.value
              }
              text={
                revisors_handling_5.revisors_handling_5_question
                  .revisors_handling_5_question_alt_2.label
              }
            >
              <label
                htmlFor={
                  revisors_handling_5
                    .revisors_handling_5_alt_2_beskriv_uoverenstemmelsen.id
                }
                className="mb-2"
              >
                {
                  revisors_handling_5
                    .revisors_handling_5_alt_2_beskriv_uoverenstemmelsen.label
                }{" "}
                <span className="text-muted">
                  {
                    revisors_handling_5
                      .revisors_handling_5_alt_2_beskriv_uoverenstemmelsen
                      .sublabel
                  }
                </span>
                :
              </label>
              <ValidatedField
                autoComplete="off"
                as="textarea"
                id={
                  revisors_handling_5
                    .revisors_handling_5_alt_2_beskriv_uoverenstemmelsen.id
                }
                name={
                  revisors_handling_5
                    .revisors_handling_5_alt_2_beskriv_uoverenstemmelsen.id
                }
                placeholder="Beskrivelse"
                rows={2}
                touched={
                  touched.revisors_handling_5_alt_2_beskriv_uoverenstemmelsen
                }
                error={
                  errors.revisors_handling_5_alt_2_beskriv_uoverenstemmelsen
                }
              />
            </RadioCard>
          </div>
        </fieldset>
      </AccordionBody>
    </AccordionItem>
  );
}
